import HoldInformationModalV2 from '../../../holdInformationV2/HoldInformationModalV2';
import CopiesAvailableTemplate from '../../templates/CopiesAvailable.html';
import getHoldPosition from '../../../../util/title-actions/getHoldPosition';
import WaitTimeHelper from '../../../../util/waitTime';

export default class CopiesAvailable extends Backbone.View {
    constructor({ withIcons }) {
        super(...arguments);
        this.title = this.model.toJSON();
        this.withIcons = withIcons;
        this.waitTimeHelper = new WaitTimeHelper({
            model: this.model,
            isVisitor: window.OverDrive.isVisitor,
        });
        this.listenTo(this.model, 'change:titleState', this._maybeRender);
        this.render();
    }

    events() {
        return {
            'click .js-holds-ratio-help-icon': '_renderModal',
        };
    }

    render() {
        this.$el.empty();
        if (this.model.allCopiesAreLuckyDay) {
            return this;
        }

        if (this.title.titleState === 'unavailable') {
            this._renderNormal();
            return this;
        } else if (this.title.isPreReleaseTitle) {
            this._renderNormal();
            return this;
        }

        switch (this.title.availabilityType) {
            case 'normal':
                this._renderNormal();
                break;
            case 'always':
                this.$el.append(
                    CopiesAvailableTemplate({
                        withIcons: this.withIcons,
                        availabilityText: window.text('cover.alwaysAvailable'),
                    })
                );
                break;
            case 'limited' && !this.title.isAvailable:
                this.$el.append(
                    CopiesAvailableTemplate({
                        withIcons: this.withIcons,
                        availabilityText: window.text(
                            'cover.limitedAvailability'
                        ),
                    })
                );
                break;
        }

        return this;
    }

    _maybeRender() {
        if (
            (window.featureManager.isEnabled('betterPatronState')
                ? this.model.get('isOnHold')
                : this.model.get('titleState') === 'onHold') ||
            (window.featureManager.isEnabled('betterPatronState')
                ? this.model.get('isBorrowed')
                : this.model.get('titleState') === 'borrowed')
        ) {
            this.render();
        }

        if (this.model.allCopiesAreLuckyDay) {
            this.render();
        }
    }

    _renderNormal() {
        let availabilityText, waitingText, helpButtonHTML;

        const notHeldClass = (
            window.featureManager.isEnabled('betterPatronState')
                ? this.model.get('isOnHold')
                : this.model.get('titleState') === 'onHold'
        )
            ? ''
            : 'js-holds-ratio-not-held';

        if (
            this.title.type.id === 'periodicals' &&
            this.title.availableCopies < 1 &&
            !this.title.isAvailable
        ) {
            availabilityText = window.html('cover.limitedAvailability');
            helpButtonHTML = `
                <button
                aria-label="${window.html('cover.whyLimitedAvailability')}"
                data-reveal-id="limited-periodical-availability"
                class="help-tip primary">
                </button>
                `;
        } else {
            let copyVariables = {
                availableCopies: window.featureManager.isEnabled('LuckyDay')
                    ? this.title.availableCopies +
                      this.title.luckyDayAvailableCopies
                    : this.title.availableCopies,
                ownedCopies: window.featureManager.isEnabled('LuckyDay')
                    ? this.title.ownedCopies + this.title.luckyDayOwnedCopies
                    : this.title.ownedCopies,
            };

            if (this.model.isPreReleaseSuTitle) {
                copyVariables['ownedCopies'] =
                    '<span class="larger-infinity">∞</span>';
            }

            availabilityText = window.html(
                'cover.copiesAvailableHtml',
                copyVariables
            );

            if (
                this.model.allCopiesAreLuckyDay &&
                this.title.titleState === 'unavailable'
            ) {
                availabilityText = window.html('cover.copiesAvailableHtml', {
                    availableCopies: 0,
                    ownedCopies: this.title.luckyDayOwnedCopies,
                });
            }

            if (
                !this.title.isAvailable &&
                !this.model.hasAvailableLuckyDayCopies
            ) {
                if (!this.model.allCopiesAreLuckyDay && this.title.isOwned) {
                    const potentialWaitText =
                        this.waitTimeHelper.waitTimeHtml();
                    waitingText =
                        potentialWaitText !== ''
                            ? `<span class='waitingText'>${potentialWaitText}</span>`
                            : '';
                }

                helpButtonHTML = !this.title.isOwned
                    ? ''
                    : ` <button
                    data-media-id="${this.title.id}"
                    aria-label="${window.html('cover.holdsRatioExplanation')}"
                    class="primary help-tip js-holds-ratio-help-icon ${notHeldClass}">
                    </button>
                    `;
            }
        }

        this.$el.append(
            CopiesAvailableTemplate({
                withIcons: this.withIcons,
                availabilityText,
                waitingText,
                helpButtonHTML,
            })
        );
    }

    _renderModal() {
        if (
            window.featureManager.isEnabled('betterPatronState')
                ? this.model.get('isOnHold')
                : this.model.get('titleState') === 'onHold'
        ) {
            window.ajax.getHold(this.model.get('id')).done((holdData) => {
                // should be confirming that this is on hold
                const holdListPosition = getHoldPosition(holdData);
                this.model.set({
                    holdsCount: holdData.holdsCount,
                    holdListPosition,
                    estimatedWaitDays: holdData.estimatedWaitDays,
                    estimatedReleaseDate: holdData.estimatedReleaseDate,
                });

                this.modal = new HoldInformationModalV2({
                    model: this.model,
                    el: this.el,
                });
            });
        } else {
            this.modal = new HoldInformationModalV2({
                model: this.model,
                el: this.el,
                hideHoldsLink: true,
            });
        }
    }
}
